<template>
  <div>
    <el-table
      :data="packages"
      stripe
      :empty-text="$t('packages.noPackagesGenerated')"
      style="width: 100%">
      <el-table-column type="expand" fixed>
        <template slot-scope="scope">
          <el-table
            :data="scope.row.lines"
            stripe
            style="width: 100%">
            <el-table-column
              prop="item.reference"
              :label="$t('packages.batchNumber')"
              width="200">
            </el-table-column>
            <el-table-column
              prop="item.product.name"
              :show-overflow-tooltip="true"
              :label="$t('packages.productName')">
              <template slot-scope="scope">
                <el-link @click="openProductDetailDrawer(scope.row.item.puid)" v-if="scope.row.item.product.type==1">{{getProductName(scope.row.item.product, scope.row.item)}}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('packages.infoSupp')">
              <template slot-scope="scope">
                <span>{{getVintage(scope.row.item)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="qty"
              :label="$t('packages.quantity')"
              width="180">
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        prop="pkNumber"
        :label="$t('packages.packgeNumber')">
      </el-table-column>
      <el-table-column
        width="150"
        :label="$t('packages.inventory')">
        <template slot-scope="scope">
          {{getInventory(scope.row.inventory.id).name}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('packages.deliveryDate')">
        <template slot-scope="props">
          <span v-if="props.row.expectedDeliveryDate!=null">{{moment(props.row.expectedDeliveryDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="# agence">
        <template slot-scope="props">
          <span v-if="props.row.agencyNumber !== 'DEFAULT'">{{props.row.agencyNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('packages.externalReferenceNumber')">
        <template slot-scope="props">
          <span v-if="props.row.externalNumber">{{ props.row.externalNumber }}</span>
          <span v-else> -- </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('packages.confirmationNumber')">
        <template slot-scope="props">
          <span>{{ props.row.confirmationNumber }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('packages.status')">
        <template slot-scope="props">
          <el-tag v-if="props.row.status" :type="packageStatusType(props.row.status)" style="margin-left:10px;">{{$t("packages.statuses."+props.row.status.code)}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        label="">
        <template slot-scope="props">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{$t('common.Actions')}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ action: 'downloadCSV', value: props.row }" v-if="isPrivateImport(props.row) && !isRejected(props.row)">
                <i class="el-icon-download" />
                {{$t('common.downloadCSV')}}
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'downloadCSV', value: props.row }" v-if="isConsignment(props.row) && !isRejected(props.row)">
                <i class="el-icon-download" />
                {{$t('common.downloadCSV')}}
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'confirm', value: props.row }" v-if="isPrivateImport(props.row) && !isConfirmed(props.row)">
                <i class="mdi mdi-checkbox-marked-circle-outline" />
                {{$t('packages.confirmed')}}
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'init', value: props.row }" v-if="!isInit(props.row)">
                <i class="mdi mdi-checkbox-blank-circle-outline" />
                {{$t('packages.setAsInit')}}
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'deliver', value: props.row }" v-if="!isPrivateImport(props.row) && !isDelivered(props.row)">
                <i class="mdi mdi-truck-delivery" />
                {{$t('packages.delivered')}}
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'reject', value: props.row }" v-if="isPrivateImport(props.row) && !isRejected(props.row)">
                <i class="mdi mdi-close-circle-multiple" />
                {{$t('packages.rejected')}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
       
      </el-table-column>
    </el-table>
    <ProductDetailDrawer :puid="selectedPuid" direction="ltr" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer"></ProductDetailDrawer>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import packageAPI from '@/services/API/package'
import packageUtil from '@/utils/package-util'
import ProductUtil from '@/utils/product-util'
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'

import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'Package-table',
	props: {
    packages : Array,
    salesOrderNumber: String,
	},
  data() {
    return {
      productDetailDrawerVisible : false,
      selectedPuid: null,
      confirmationLoading: null,
    };
  },components: {
    ProductDetailDrawer
  },
  watch : {

  },
	methods: {
    handleCommand (command) {
      console.log(command);
      // this.$message('click on item ' + command);
      return new Promise ((resolve, reject) => {
        if (command.action == null) reject();

        if (command.action === 'confirm'){
          return this.confirm(command.value);
        } else if (command.action === 'init') {
          return this.init(command.value);
        } else if (command.action === 'deliver') {
          return this.deliver(command.value);
        }else if (command.action === 'reject') {
          return this.reject(command.value);
        } else if (command.action === 'downloadCSV') {
          return this.downloadCSV(command.value)
        }

        reject();
      }).catch((err) => {
        console.log(err);
        this.$message.error('Ouups, ceci est une erreur.');
      })
    },
    isPrivateImport (packageInfos) {
      return _.get(this.getInventory(_.get(packageInfos, 'inventory.id')), 'code') === 'IP';
    },
    isConsignment(packageInfos) {
      return _.get(this.getInventory(_.get(packageInfos, 'inventory.id')), 'code') === 'PI';
    },
    isConfirmed(packageInfo) {
      return _.get(packageInfo, 'status.code') === 'CONFIRMED';
    },
    isDelivered(packageInfo) {
      return _.get(packageInfo, 'status.code') === 'DELIVERED';
    },
    isInit(packageInfo) {
      return _.get(packageInfo, 'status.code') === 'INIT';
    },
    isRejected(packageInfo) {
      return _.get(packageInfo, 'status.code') === 'REJECTED';
    },
    reject (packageInfo) {
      this.confirmationLoading = true;
      return packageAPI.reject(packageInfo.id)
          .then((packageUpdated) => {
            this.confirmationLoading = false;
            this.$emit('packageUpdated', packageUpdated);
          }).catch((err) => {
            this.confirmationLoading = false;
          })
    },
    confirm (packageInfo) {
      this.confirmationLoading = true;
      this.$prompt(this.$i18n.t('sales_orders.EnterExternalSONumber'),this.$i18n.t('sales_orders.OrderConfirmation'),{
        confirmButtonText: this.$i18n.t('common.ok'),
        cancelButtonText: this.$i18n.t('common.Cancel'),
        inputValue: packageInfo.confirmationNumber,
      }).then((value) => {
        return packageAPI.confirm(packageInfo.id, value.value)
          .then((packageUpdated) => {
            this.confirmationLoading = false;
            this.$emit('packageUpdated', packageUpdated);
          });
      }).catch((err) => {
        console.log(err);
        this.confirmationLoading = false;
      })
    },
    init (packageInfo) {
      this.confirmationLoading = true;
      return packageAPI.init(packageInfo.id)
          .then((packageUpdated) => {
            this.confirmationLoading = false;
            this.$emit('packageUpdated', packageUpdated);
          }).catch((err) => {
            this.confirmationLoading = false;
          })
    },
    deliver (packageInfo) {
      this.confirmationLoading = true;
      return packageAPI.deliver(packageInfo.id)
          .then((packageUpdated) => {
            this.confirmationLoading = false;
            this.$emit('packageUpdated', packageUpdated);
          }).catch((err) => {
            this.confirmationLoading = false;
          })
    },
    downloadCSV (packageInfo) {
      let filename = packageInfo.agencyNumber === 'DEFAULT' ? `${this.salesOrderNumber}-${packageInfo.pkNumber}.xlsx` : `${this.salesOrderNumber}-${packageInfo.pkNumber}-${packageInfo.agencyNumber}.xlsx`
      return packageAPI.getReport(packageInfo.id, {format: 'CSV'}, filename)
        .catch((err) => {
          console.log(err);
          console.log('oupss');
        })
    },
    getVintage (item) {
      return _.get(item, 'extraInfo.vintage');
    },
    getProductName (product, item) {
      let localProduct = _.cloneDeep(product);
      localProduct.item = item;
      return ProductUtil.getExtendedProductName(localProduct);
    },
    closeProductDetailDrawer(){
      this.productDetailDrawerVisible=false;
    },
    openProductDetailDrawer(puid){
      this.selectedPuid = puid;
      this.productDetailDrawerVisible=true;
    },
    moment(datetime){
      return  moment(datetime).format('L');
    },
    packageStatusType(status){
      return packageUtil.getPackageStatusTagType(status);
    },
	},
	computed: {
    ...mapGetters('inventory',['getInventory'])
	},
  created(){
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';



</style>
